import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useToggle } from 'react-use';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import clsx from 'clsx';

import { useGlobalContext } from '../../../containers/App/context';
import { LeftAsideProvider } from '../../../providers/LeftAsideProvider';
import { RightAsideProvider } from '../../../providers/RightAsideProvider';

import { CustomProgress } from '../../atoms';
import Aside from '../Aside';

import { useStyles } from './styled';
import TopNav from '../TopNav';

const Root = ({ children, isShowMain }) => {
  const { globalLoading, sidebarWidth, isCustomerSupportRole } = useGlobalContext();

  const classes = useStyles({ sidebarWidth, isCustomerSupportRole });
  const { pathname } = useLocation();
  const [globalFilterState, toggleGlobalFilterState] = useToggle(false);

  useEffect(() => {
    return () => {
      // unsubscribe
      toggleGlobalFilterState(false);
    };
  }, [pathname, toggleGlobalFilterState]);

  return (
    <div className={classes.root}>
      <CssBaseline />

      <Box>
        {globalLoading && <CustomProgress />}

        {isCustomerSupportRole && <TopNav />}

        <LeftAsideProvider>
          <Aside isCustomerSupportRole={isCustomerSupportRole} />
        </LeftAsideProvider>

        {isShowMain && (
          <RightAsideProvider value={{ globalFilterState, toggleGlobalFilterState }}>
            <main className={clsx(classes.content, { [classes.contentFiltered]: globalFilterState })}>{children}</main>
          </RightAsideProvider>
        )}
      </Box>
    </div>
  );
};

Root.propTypes = {
  isShowMain: PropTypes.bool.isRequired,
};

export default Root;
